var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_8999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3955 11.3211C12.4983 10.1996 13.1786 8.66137 13.1786 6.96429C13.1786 3.53223 10.3963 0.75 6.96429 0.75C3.53223 0.75 0.75 3.53223 0.75 6.96429C0.75 10.3963 3.53223 13.1786 6.96429 13.1786C8.69925 13.1786 10.2682 12.4676 11.3955 11.3211ZM11.3955 11.3211L15.25 15.25",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_8999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridSearchIcon);
export default __webpack_public_path__ + "static/media/grid-search-icon.27a4cba1659490aab391ffa6a35a086b.svg";
export { ForwardRef as ReactComponent };